module.exports = __webpack_public_path__ + "img/01uni-doll.aa7282c5.png";